export default "__VITE_ASSET__baf4fbce__"